const boardSlider = document.querySelector('.board-slider');
let boardSliderInstance = {};
const boardSettingsSlider = {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  pagination: {
    el: '.board .swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.board .swiper-button-next',
    prevEl: '.board .swiper-button-prev',
  },
  breakpoints: {
    767: {
      spaceBetween: 0,
      slidesPerView: 4,
    }
  }
}

window.addEventListener('load', boardSwiperOnLoadOrResize);
window.addEventListener('resize', boardSwiperOnLoadOrResize);

function boardSwiperOnLoadOrResize() {
  if (window.innerWidth > 767) {
    if(!boardSlider.classList.contains('swiper-initialized') && boardSlider.classList.contains('desktop_slider') ){
      boardSliderInstance = new Swiper('.board-slider', boardSettingsSlider);
    } else if (boardSlider.classList.contains('swiper-initialized') && !boardSlider.classList.contains('desktop_slider')) {
      boardSliderInstance.destroy({
        deleteInstance: true,
        cleanStyles: true
      });
    }
  } else {
    if (!boardSlider.classList.contains('swiper-initialized')) {
      boardSliderInstance = new Swiper('.board-slider', boardSettingsSlider);
    }
  }
}

// Popup slider
const boardPopupSlider = new Swiper('.board-popup-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  watchSlidesProgress: true,
  pagination: {
    el: '.board-popup .swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.board-popup .swiper-button-next',
    prevEl: '.board-popup .swiper-button-prev',
  },
  breakpoints: {
    767: {
      spaceBetween: 0,
    }
  }
});

const boardPopup = document.querySelector('.board-popup');
const openBoardPopupButtons = document.querySelectorAll('.board-open-popup');
const closeBoardPopupButtons = document.querySelectorAll('.board-close-popup');

openBoardPopupButtons.forEach(button => {
  button.addEventListener('click', event => {
    const idx = Number(button.dataset.idx);
    boardPopupSlider.slideToLoop(idx);
    setTimeout(() => {
      boardPopup.classList.remove('invisible', 'opacity-0');
    }, 300);
  });
});

closeBoardPopupButtons.forEach(button => {
  button.addEventListener('click', event => {
    boardPopup.classList.add('invisible', 'opacity-0');
  });
});